import { EventManager } from '../../utilities/events';
import { ContextConsumer, provide } from '@lit/context';
import { organisationContext } from '../../utilities/context';
export const AllInOrganisationConsumer = (superClass) => class extends superClass {
    static properties = {
        ...super.properties,
        organisationData: { type: Object, state: true },
        name: { type: String, state: true },
        organisations: { type: Array, state: true },
        organisation: { type: Object, state: true },
        user: { type: Object, state: true },
        currentOrg: { type: String, state: true },
        dashboard: { type: String, state: true },
        panel: { type: String, state: true },
        view: { type: String, state: true },
        subview: { type: String, state: true },
        panels: { type: Array, state: true },
        restUrl: { type: String, state: true },
        action: { type: String, state: true },
        nonce: { type: String, state: true },
        provisions: { type: Array, state: true },
        zoneProvisions: { type: Array, state: true },
        integration_panels: { type: Object, state: true },
        support_org_language_texts: { type: Object, state: true },
        org_events_language_texts: { type: Object, state: true },
        member_lookup_texts: { type: Object, state: true },
        eventProvisions: { type: Array, state: true },
        memberProvisions: { type: Array, state: true },
        location: { type: Object, state: true },
        providerConfig: { type: Object, state: true },
        providerConfigMapping: { type: Object, state: true },
        hardlinks: { type: Object, state: true },
        members: { type: Object, state: true },
        membersLookedUp: { type: Object, state: true },
    };
    connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this._organisationData = new ContextConsumer(this, { context: organisationContext, callback: this._handleContextUpdate.bind(this), subscribe: true });
        this.groupFlag = true;
        this.supportFlag = true;
        this._populateStateFromContext();
    }
    _updateContext(props) {
        this.eventManager.emit(`allin-organisation-${this.name}-update`, props);
    }
    _handleContextUpdate(value) {
        this.organisationData = value;
        this._populateStateFromContext();
    }
    _setDocumentTitle(title) {
        document.title = `${title} - All In`;
    }
    _populateStateFromContext() {
        this._beforeContextUpdate();
        ({
            currentOrg: this.currentOrg,
            name: this.name,
            dashboard: this.dashboard,
            panel: this.panel,
            //view:this.view,
            subview: this.subview,
            panels: this.panels,
            action: this.action,
            user: this.user,
            restUrl: this.restUrl,
            nonce: this.nonce,
            organisations: this.organisations,
            organisation: this.organisation,
            location: this.location,
            provisions: this.provisions,
            zoneProvisions: this.zoneProvisions,
            eventProvisions: this.eventProvisions,
            integration_panels: this.integration_panels,
            support_org_language_texts: this.support_org_language_texts,
            org_events_language_texts: this.org_events_language_texts,
            member_lookup_texts: this.member_lookup_texts,
            members: this.members,
            membersLookedUp: this.membersLookedUp,
            providerConfig: this.providerConfig,
            providerConfigMapping: this.providerConfigMapping,
            hardlinks: this.hardlinks,
            memberProvisions: this.memberProvisions
        } = this.organisationData);
        if (!this.view) {
            this.view = this.organisationData.view;
        }
        this.organisation = this._getOrganisationById(this.currentOrg);
        this._afterContextUpdate();
        this.requestUpdate();
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    async _afterContextUpdate() {
        // Hook for subclasses
    }
    _beforeContextUpdate() {
        //Hook for subclasses
    }
};
